import { Navigate } from "react-router-dom";
import { isEnphaseUser } from "../utils/featureAccess";
import StationSection from "../../pages/sections/StationSection";

export default function EnphaseStationsRoute() {
  if (isEnphaseUser()) {
    return <Navigate to="/fleet" replace />;
  }
  return <StationSection />;
}
